// extracted by mini-css-extract-plugin
export default {"Container":"AppShellProvider_Container__ku+J2","header":"AppShellProvider_header__KvmcT"};